<template>
    <div v-if="loading||controlPoints||(showMissingSensors&&missingSensors&&missingSensors.length>0)">
        <loading-progress-bar v-if="loading" :loading="loading" color="secondary"></loading-progress-bar>
        <v-layout row wrap v-if="!loading&&controlPoints">
            <v-flex v-for="(itemsArray,equipName) in controlPoints" v-bind:class="['md'+equipmentColWidth, 'xs12']">
                <v-card flat>
                    <v-card-title class="accent white--text title">
                        {{equipName}}
                    </v-card-title>
                        <v-layout row wrap>
                            <v-flex v-for="item in itemsArray" v-bind:class="['md'+colWidth, 'xs12']">
                                <a @click="editItem(item)" class="cursor-as-pointer">
                                    <value-box :white-mode="whiteMode" :value="item.value" :unit="item.unit&&item.unit!=='_' ? item.unit : ''" :title="item.sensor_name" has-comma :title-size="14" :sub-text="getItemSubText(item)"></value-box>
                                </a>
                            </v-flex>
                        </v-layout>
                </v-card>
            </v-flex>
        </v-layout>
        <div v-if="showMissingSensors&&missingSensors&&missingSensors.length>0" class="pa-2">
            <v-alert
                     :value="true"
                     style="padding: 6px;"
                     type="warning"
            >
                {{'Missing writable points : '|translate}}
                <v-chip  v-for="missingSensor in missingSensors" >{{missingSensor}} <v-icon small class="ml-2" @click="addMissingSensor(missingSensor)">fa-plus</v-icon></v-chip>
            </v-alert>
            <point-record-dialog v-if="$can('update', 'Points')" v-model="addMissingItemDialog" :item="addMissingItem" v-on:reloadpoints="fullRefresh(); addMissingItemDialog=false"></point-record-dialog>
        </div>
        <v-dialog v-model="editDialog" :max-width="1200">
            <v-card v-if="editDialog&&editedItem">
                <v-card-title class="primary white--text title">
                    {{editedItem.equipment_name}} - {{editedItem.sensor_name}}
                </v-card-title>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <data3-chart
                                :layout-overrides="layoutOverrides" :on-only="false"
                                :x-axis="'timestamp'"
                                disable-responsive
                                :show-export="false"
                                just-plot
                                :data-payload="chartPayload"
                                :date-range="dateRange"></data3-chart>
                        </v-flex>
                        <v-flex xs12 md6 v-if="editedItem.meta.writable_priority_array">
                            <ol>
                                <li v-for="(item,priority) in editedItem.meta.writable_priority_array">
                                    <span v-if="item">{{item.value}}  {{formatElderDate(item.deadline)}}
                                     <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon small v-on="on" class="ml-3"
                                                    @click="clearPriority(editedItem.sensor_id,priority+1)">fa-trash</v-icon>
                                        </template>
                                        <span>{{ 'Clear & Save'|translate }}</span>
                                    </v-tooltip>
                                    </span>
                                    <span v-if="!item">null</span>
                                </li>
                            </ol>
                        </v-flex>
                        <v-flex xs12 :class="editedItem.meta.writable_priority_array ? 'md6': ''">
                            <v-text-field :label="'Sensor ID'|translate" v-model="editedItem.sensor_id" disabled></v-text-field>
                            <v-text-field v-if="!editedItem.calculations_statement||editedItem.calculations_statement===''" :label="'Upstream ID'|translate" v-model="editedItem.haystack_id" disabled></v-text-field>
                            <v-text-field v-if="editedItem.calculations_statement&&editedItem.calculations_statement!==''" :label="'Calculation Statement'|translate" v-model="editedItem.calculations_statement" disabled></v-text-field>
                            <v-text-field v-if="!editedItem.calculations_statement||editedItem.calculations_statement===''" :label="'Value'|translate" v-model.number="editedItem.value" clearable :rules="editedItem.meta.writable_value_range ? [value => value < editedItem.meta.writable_value_range[0] || 'Min value is '+editedItem.meta.writable_value_range[0], value => value > editedItem.meta.writable_value_range[1] || 'Max value is '+editedItem.meta.writable_value_range[1]] : []"></v-text-field>
                            <v-text-field v-if="!editedItem.calculations_statement||editedItem.calculations_statement===''" :label="'Priority'|translate" v-model.number="editedItem.priority"></v-text-field>
                        </v-flex>
                    </v-layout>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="primary" @click="updateControl(editedItem.sensor_id,editedItem.value,editedItem.priority)" :disabled="!$can('update', 'SoftwareSwitches')" v-if="!editedItem.calculations_statement||editedItem.calculations_statement===''">{{'Write Value'|translate}}</v-btn>
                    <v-btn @click="editDialog=false">{{'Cancel'|translate}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import LoadingProgressBar from "../LoadingProgressBar";
import ValueBox from "../ValueBox.vue";

import _ from "lodash";
import {getPoint, callAPI, putOptimizationControl} from "../../helper";
import VuePlotly from "../VuePlotly.vue";
import moment from "moment/moment";
import Data3Chart from "../Data3Chart.vue";
import PointRecordDialog from "../points/PointRecordDialog.vue";

export default {
    props: {
        whiteMode: {type: Boolean, default: false},
        showPriorities: {type: Boolean, default: false},
        specificSensors: {type: String, default: null},
        showMissingSensors: {type: Boolean, default: false},
        equipment: {type:String, default: null},
        defaultEquipment: {type:String, default: null},
        followEquipment: {type:Boolean, default: false},
        useRelationship: {type:Boolean, default: false},
        relationshipType: {type:String, default: null},
        dateRange: {type: Object, default: null},
        colWidth: {type: Number, default: 12},
        equipmentColWidth: {type: Number, default: 12},

    },
    components: {Data3Chart, VuePlotly, LoadingProgressBar,ValueBox,PointRecordDialog},
    mixins:[],
    computed: {
        chartPayload(){
            if (!this.editedItem){
                return null
            }
            return [{
                filters: {
                    equipment_name: this.editedItem.equipment_name,
                    sensor_name: this.editedItem.sensor_name,
                    facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
                },
                pipeline: [],
                showlegend:false,
                seriesOverrides: {
                    type: 'scatter',
                    opacity: 1,
                    xbins: {
                        size: 1
                    },
                    ybins: {
                        size: 1
                    }
                },
            }]
        },
    },
    name: 'OptimizationControlWidget',
    data: function () {
        return {
            controlPoints:null,
            writablePoints:null,
            missingSensors:[],
            addMissingItem:null,
            addMissingItemDialog:false,
            config:null,
            nameMap:{},
            loading:false,
            timeout:null,
            editedItem:null,
            editDialog:false,
            layoutOverrides:{
                xaxis: {
                    title: '',
                },
                yaxis:{
                    fixedrange: true
                },
                height:300,
                showlegend:false,
                legend: {
                    orientation:'h',
                    y: -0.2,
                },
                hoverlabel: {
                    namelength: -1
                },
                hovermode:"x",
            }
        }
    },
    watch: {
        dateRange() {
            this.refresh()
        },
        equipment() {
            if (this.followEquipment) {
                this.refresh()
            }
        },
    },
    async mounted () {
        await this.fullRefresh()
    },
    methods: {
        async fullRefresh(){
            let pointsDf = await getPoint({
                facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
            })
            let writablePoints=_.filter(
                pointsDf['result'],
                function (x) {
                    return x.meta&& x.meta.tags && x.meta.tags.includes('writable')
                })
            for (let point of writablePoints){
                let equipment = this.$store.state.pointsListStore.pointsList.equipment_details[point.equipment_name]
                if (equipment){
                    point.equipment_type=equipment.equipment_type
                    point.floor=equipment.floor
                }
            }
            let newMappings={}
            for (let equip of Object.values(this.$store.state.pointsListStore.pointsList.equipment_details)){
                newMappings[equip.equipment_id]=equip.equipment_name
            }
            this.nameMap=newMappings
            this.writablePoints= writablePoints
            this.refresh()
        },
        addMissingSensor(item){
            this.addMissingItem={'facility_name': this.$store.state.pointsListStore.pointsList.facility_name,'equipment_name':item.split(' - ')[0],'sensor_name':item.split(' - ')[1]}
            this.addMissingItemDialog=true
        },
        getItemSubText(item){
            if (this.showPriorities&&item.meta&&item.meta.writable_priority_array){
                let result=''
                for (let index in item.meta.writable_priority_array){
                    let level=parseInt(index)+1
                    let curItem=item.meta.writable_priority_array[index]
                    if (curItem&&curItem.value!==null&&(!curItem.deadline||moment(curItem.deadline).isAfter(moment()))){
                        result=result+curItem.value.toLocaleString()+'('+level+')  '
                    }
                }
                return result
            }
            return null
        },
        formatElderDate(date){
            return moment(date).format('YYYY-MM-DD HH:mm:ss')
        },
        editItem(item){
            this.editedItem=JSON.parse(JSON.stringify(item))
            this.editedItem.priority=8
            this.editDialog=true
        },
        async clearPriority(sensor_id,priority){
            await putOptimizationControl({
                'sensor_id': sensor_id,
                'value': null,
                'priority': priority,
            })
            this.editDialog = false
            this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Update request sent')})
            this.refresh()
        },
        async updateControl(sensor_id, value, priority) {
            await putOptimizationControl({
                'sensor_id': sensor_id,
                'value': value===""||value==="null" ? null : value,
                'priority': priority&&priority!=="" ? priority : 8,
            })
            this.editDialog = false
            this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Update request sent')})
            this.refresh()
        },
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout= setTimeout(() => callback(), wait);
        },
        refresh(){
            this.debounce(this.getData,500);
        },
        async getData(){
            this.loading=true
            this.missingSensors=[]
            this.controlPoints=null
            let availablePoints=JSON.parse(JSON.stringify(this.writablePoints))
            let equipment = null
            let selectedEquipments=[]
            if (this.followEquipment&&this.equipment){
                equipment = this.equipment
            } else if (this.defaultEquipment&&this.$store.state.pointsListStore.pointsList.equipment_details[this.defaultEquipment]){
                equipment = this.defaultEquipment
            }
            if (equipment){
                if (this.useRelationship){
                    let masterId=this.$store.state.pointsListStore.pointsList.equipment_details[equipment].equipment_id
                    let relationships=this.$store.state.pointsListStore.pointsList.equipment_relationships.filter(x=>x.equip1===masterId)
                    if (this.relationshipType){
                        relationships=relationships.filter(x=>x.type===this.relationshipType)
                    }
                    for (let relationship of relationships){
                        let equip2=this.nameMap[relationship.equip2]
                        if (equip2&&selectedEquipments.indexOf(equip2)===-1){
                            selectedEquipments.push(equip2)
                        }
                    }
                    selectedEquipments.sort()
                } else {
                    selectedEquipments.push(equipment)
                }
            }
            if (selectedEquipments.length>0&&this.specificSensors&&this.specificSensors!==""){
                let missingSensors=[]
                let specificSensors=this.specificSensors.split(',').map(x=>x.trim())
                for (let equipment of selectedEquipments){
                    for (let sensor of specificSensors){
                        if (!availablePoints.find(x=>x.equipment_name===equipment&&x.sensor_name===sensor)){
                            missingSensors.push(equipment+' - '+sensor)
                        }
                    }
                }
                this.missingSensors=missingSensors
            }
            if (selectedEquipments.length>0&&availablePoints&&availablePoints.length>0){
                let selectedPoints=availablePoints.filter(x=>selectedEquipments.indexOf(x.equipment_name)!==-1)
                if (this.specificSensors&&this.specificSensors!==""){
                    let specificSensors=this.specificSensors.split(',').map(x=>x.trim())
                    selectedPoints=selectedPoints.filter(x=>specificSensors.indexOf(x.sensor_name)!==-1)
                    selectedPoints.sort((a, b) => (specificSensors.indexOf(a.sensor_name) > specificSensors.indexOf(b.sensor_name)) ? 1 : -1)
                } else {
                    selectedPoints.sort((a, b) => (a.sensor_name > b.sensor_name) ? 1 : -1)
                }
                let data = await callAPI(
                    "latest-readings/",
                    {latest_only: true},
                    'post'
                )
                if(data&&data.data&&data.data.result&&data.data.result.length>0){
                    let updatedData = _.filter(
                        data.data.result,
                        function (x) {
                            return x.meta.tags && x.meta.tags.includes('writable')
                        }
                    )
                    for (let updatedPoint of updatedData){
                        for (let point of selectedPoints){
                            if (point.sensor_id===updatedPoint.sensor_id){
                                point.value=updatedPoint.value
                                point.meta=updatedPoint.meta
                            }
                        }
                    }
                    this.controlPoints=selectedPoints.reduce((grouped, item) => {
                        let key = item.equipment_name;
                        if (!grouped[key]) {
                            grouped[key] = [];
                        }
                        grouped[key].push(item);
                        return grouped;
                    }, {});
                }
            }
            this.loading=false
        }
    }
}

</script>

<style scoped>

</style>
